/**
 * Formato do codigo de convite, num lugar so: o servidor gera por aqui e a
 * tela de login valida por aqui. Separar os dois foi o que criou, no passado,
 * telas que recusavam codigos que o servidor aceitava.
 *
 * Forma: LJ + 16 caracteres sorteados + MM, 20 no total.
 * O alfabeto nao tem I, O, 0 nem 1 — sao os que as pessoas confundem ao ditar.
 */
export const INVITE_ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
export const INVITE_PREFIX = 'LJ';
export const INVITE_SUFFIX = 'MM';
export const INVITE_BODY_LENGTH = 16;
export const INVITE_LENGTH = INVITE_PREFIX.length + INVITE_BODY_LENGTH + INVITE_SUFFIX.length;

/** Serve de placeholder e de exemplo na interface. */
export const INVITE_EXAMPLE = `${INVITE_PREFIX}${'X'.repeat(INVITE_BODY_LENGTH)}${INVITE_SUFFIX}`;

/**
 * Tira espacos e hifens e sobe para maiuscula. Quem digita costuma agrupar o
 * codigo em blocos, e recusar por causa disso so gera confusao.
 */
export function normalizeInviteCode(code: string): string {
  return code.trim().toUpperCase().replace(/[\s-]+/g, '');
}

/**
 * Confere se o codigo tem a forma certa. Nao diz se ele existe ou se ainda
 * vale — isso e o servidor que responde.
 */
export function isInviteCodeShaped(code: string): boolean {
  const normalized = normalizeInviteCode(code);
  if (normalized.length !== INVITE_LENGTH) return false;
  if (!normalized.startsWith(INVITE_PREFIX)) return false;
  if (!normalized.endsWith(INVITE_SUFFIX)) return false;
  const body = normalized.slice(INVITE_PREFIX.length, INVITE_PREFIX.length + INVITE_BODY_LENGTH);
  return [...body].every((char) => INVITE_ALPHABET.includes(char));
}
